import { IconSvgProps } from "@/types";

export const BoxIcon = ({
  size = 32,
  width,
  height,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      height={size || height}
      role="presentation"
      viewBox={`0 0 ${size || width} ${size || height}`}
      width={size || width}
      {...props}
      fill="none"
    >
      <path
        d="M26.5 20.6669V11.3335C26.4996 10.9244 26.3916 10.5225 26.1868 10.1682C25.982 9.81398 25.6877 9.5198 25.3333 9.31521L17.1667 4.64854C16.812 4.44375 16.4096 4.33594 16 4.33594C15.5904 4.33594 15.188 4.44375 14.8333 4.64854L6.66667 9.31521C6.31231 9.5198 6.01798 9.81398 5.81321 10.1682C5.60843 10.5225 5.50042 10.9244 5.5 11.3335V20.6669C5.50042 21.0761 5.60843 21.4779 5.81321 21.8322C6.01798 22.1864 6.31231 22.4806 6.66667 22.6852L14.8333 27.3519C15.188 27.5567 15.5904 27.6645 16 27.6645C16.4096 27.6645 16.812 27.5567 17.1667 27.3519L25.3333 22.6852C25.6877 22.4806 25.982 22.1864 26.1868 21.8322C26.3916 21.4779 26.4996 21.0761 26.5 20.6669Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.81641 10.1172L16.0014 16.0089L26.1864 10.1172"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 27.76V16"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const LogoutIcon = ({
  size = 32,
  width,
  height,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      height={size || height}
      role="presentation" 
      viewBox={`0 0 ${size || width} ${size || height}`}
      width={size || width}
      {...props}
      fill="none"
    >
      <path
        d="M12.25 27.25H7.25C6.58696 27.25 5.95107 26.9866 5.48223 26.5178C5.01339 26.0489 4.75 25.413 4.75 24.75V7.25C4.75 6.58696 5.01339 5.95107 5.48223 5.48223C5.95107 5.01339 6.58696 4.75 7.25 4.75H12.25"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 22.25L27.25 16L21 9.75"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.25 16H12.25"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const CreditCardIcon = ({
  size = 32,
  width,
  height,
  ...props
}: IconSvgProps) => {
  return (
    <svg 
      aria-hidden="true"
      focusable="false"
      height={size || height}
      role="presentation" 
      viewBox="0 0 24 24"
      width={size || width}
      {...props}
      fill="none"
    >
     <path d="M19.499 4.43555C20.9164 4.43572 22.0654 5.58551 22.0654 7.00293V17.0029C22.0653 18.4202 20.9163 19.5692 19.499 19.5693H4.49902C3.0816 19.5693 1.93182 18.4203 1.93164 17.0029V7.00293C1.93164 5.5854 3.08149 4.43555 4.49902 4.43555H19.499Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
     <path d="M2.83203 10.3359H21.1654" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export const ArrowRightIcon = ({
  size = 32,
  width,
  height,
  ...props
}: IconSvgProps) => {
  return (
    <svg 
      aria-hidden="true" 
      focusable="false" 
      height={size || height} 
      role="presentation" 
      viewBox={`0 0 ${size || width} ${size || height}`} 
      width={size || width} {...props} 
      fill="none"
    >
      <path d="M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 5L19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export const ArrowLeftIcon = ({
  size = 32,
  width,
  height,
  ...props
}: IconSvgProps) => {
  return (
    <svg aria-hidden="true" focusable="false" height={size || height} role="presentation" viewBox={`0 0 18 18`} width={size || width} {...props} fill="none">
      <path d="M14.25 9L3.75 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 14.25L3.75 9L9 3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>  
  )
}

export const MirIcon = ({
  width = 36,
  height = 25,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width={width}
      height={height}
      role="presentation"
      viewBox="0 0 36 25"
      fill="none"
      {...props}
    >
      <path d="M9.10585 13.4165C9.15276 13.2394 9.28835 13.1942 9.28835 13.0618C9.60759 11.9511 9.92568 10.8855 10.289 9.86412C10.5155 9.10909 11.0624 8.75391 11.7907 8.75391C12.5636 8.75391 13.2004 8.75391 13.9739 8.75391C14.2925 8.75391 14.3377 8.9315 14.3377 9.19788C14.3377 11.5953 14.3377 14.0375 14.3377 16.4349C14.3377 16.746 14.2925 16.7907 13.9739 16.7907C13.3818 16.7907 12.6998 16.7907 12.1077 16.7907C11.7902 16.7907 11.7444 16.6131 11.7444 16.4349C11.7444 15.2806 11.7444 14.0375 11.7444 12.8831C11.7444 12.6614 11.7444 12.4392 11.7444 12.2616C11.6992 12.2616 11.6992 12.2616 11.5625 12.2616C11.5167 12.4392 11.3794 12.5726 11.3348 12.7061C10.8799 14.038 10.5155 15.3247 10.1528 16.6572C10.1076 16.7019 9.92625 16.8348 9.69798 16.8348C9.33355 16.8348 8.92449 16.8348 8.51487 16.8348C8.19621 16.8348 8.15158 16.7907 8.06005 16.4791C7.69619 15.1471 7.24137 13.8599 6.78654 12.528C6.78654 12.3504 6.74135 12.2169 6.74135 12.084H6.69558C6.69558 12.261 6.64981 12.3945 6.64981 12.528C6.64981 13.7711 6.64981 15.103 6.64981 16.3467C6.64981 16.7907 6.46903 16.8789 6.1046 16.8789C5.51304 16.8789 4.92263 16.8789 4.28531 16.8789C3.96664 16.8789 3.92145 16.8348 3.92145 16.5232C3.92145 14.1268 3.92145 11.6395 3.92145 9.19788C3.87625 8.8427 3.96664 8.79858 4.19434 8.79858C5.01302 8.79858 5.78593 8.79858 6.60461 8.79858C7.24137 8.79858 7.74138 9.15376 7.87926 9.81944C8.24255 10.9302 8.51487 11.9952 8.8793 13.1048C8.92507 13.2824 9.06066 13.4159 9.06066 13.5488C9.01546 13.4165 9.10585 13.4165 9.10585 13.4165Z" fill="#40A548" />
      <path d="M18.5484 13.6466C18.596 13.4677 18.736 13.3322 18.7831 13.1978C19.3442 12.0759 19.8588 10.9981 20.4188 9.78654C20.7464 9.15815 21.261 8.79907 21.9621 8.79907C22.5703 8.79907 23.132 8.79907 23.739 8.79907C24.0672 8.79907 24.113 8.84368 24.113 9.15759C24.113 11.5814 24.113 14.0955 24.113 16.5644C24.113 16.788 24.0672 16.8789 23.7854 16.8789C23.1778 16.8789 22.4768 16.8789 21.8686 16.8789C21.5404 16.8789 21.401 16.8343 21.4939 16.5198C21.4939 15.1733 21.4939 13.9159 21.4939 12.6146C21.4939 12.435 21.4939 12.3007 21.3075 12.0759C21.2604 12.2555 21.1204 12.3001 21.0734 12.4345C20.5129 13.5574 19.9982 14.7239 19.4371 15.8457C19.1089 16.6096 18.5954 16.8783 17.7544 16.8783C17.1462 16.8783 16.5863 16.8783 15.9775 16.8783C15.7434 16.8783 15.6034 16.8337 15.6493 16.5639C15.6493 14.0503 15.6493 11.626 15.6493 9.06782C15.6493 8.84368 15.6964 8.75391 15.9775 8.75391C16.6315 8.75391 17.3803 8.75391 18.0343 8.75391C18.3619 8.75391 18.3619 8.93288 18.3619 9.11242C18.3619 10.3692 18.3619 11.626 18.3619 12.9725C18.3619 13.1521 18.3619 13.3316 18.3619 13.5111C18.3619 13.5574 18.4566 13.6466 18.5484 13.6466Z" fill="#40A548" />
      <path d="M24.7656 8.75391C24.9583 8.75391 25.1048 8.75391 25.1528 8.75391C27.0856 8.75391 28.9699 8.75391 30.9027 8.75391C32.7389 8.75391 34.1411 10.2538 33.8518 11.7123C33.8518 11.7537 33.8518 11.7537 33.8032 11.8789C33.5613 11.8789 33.32 11.8789 33.1267 11.8789C31.6771 11.8789 30.3241 11.8789 28.9225 11.8789C27.1829 11.8789 25.4907 10.7951 24.9109 9.33667C24.8136 9.12861 24.7656 8.96196 24.7656 8.75391Z" fill="#1291D0" />
      <path d="M33.8943 12.6315C33.655 13.5943 32.5486 14.2936 31.444 14.3811C30.4832 14.3811 29.6185 14.3811 28.6565 14.3811C28.3211 14.3811 28.1773 14.4251 28.1773 14.731C28.1773 15.2998 28.1773 15.8682 28.1773 16.5251C28.1773 16.7435 28.129 16.875 27.8407 16.875C27.1676 16.875 26.3995 16.875 25.7747 16.875C25.5348 16.875 25.4387 16.831 25.4387 16.5686C25.4387 15.3433 25.4387 14.1192 25.4387 12.8064C25.3904 12.6315 25.4387 12.5 25.678 12.5C28.2722 12.5 30.963 12.5 33.6054 12.5C33.7505 12.5435 33.7982 12.6315 33.8943 12.6315Z" fill="#40A548" />
    </svg>
  )
}

export const VisaMastercardIcon = ({
  width = 37,
  height = 25,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width={width}
      height={height}
      role="presentation"
      viewBox="0 0 37 25"
      fill="none"
      {...props}
    >
      <path d="M18.583 17.145H16.0664L17.6405 8.39453H20.157L18.583 17.145Z" fill="#77A0F1" />
      <path d="M27.7093 8.60692C27.2129 8.42986 26.4256 8.23438 25.4521 8.23438C22.9669 8.23438 21.2168 9.42586 21.2061 11.1293C21.1854 12.3861 22.4591 13.0842 23.4117 13.5033C24.3853 13.9315 24.7163 14.211 24.7163 14.5927C24.7064 15.1789 23.9295 15.4491 23.205 15.4491C22.2002 15.4491 21.6618 15.3098 20.8437 14.9837L20.5123 14.8439L20.1602 16.8081C20.7504 17.0499 21.8379 17.2644 22.9669 17.2738C25.6075 17.2738 27.3266 16.1008 27.347 14.2855C27.357 13.2893 26.6845 12.5261 25.2345 11.9024C24.3543 11.502 23.8153 11.232 23.8153 10.8224C23.8256 10.4499 24.2712 10.0685 25.2648 10.0685C26.083 10.0498 26.6841 10.2266 27.1395 10.4035L27.3671 10.4965L27.7093 8.60692Z" fill="#77A0F1" />
      <path fillRule="evenodd" clipRule="evenodd" d="M32.2097 8.40234H34.1563L36.1866 17.1527H33.8565C33.8565 17.1527 33.6284 16.1473 33.5562 15.84H30.325C30.2316 16.0727 29.7969 17.1527 29.7969 17.1527H27.1562L30.8944 9.12837C31.1534 8.56047 31.6094 8.40234 32.2097 8.40234ZM32.0594 11.6034C32.0594 11.6034 31.2619 13.549 31.0547 14.0517H33.1465C33.043 13.6142 32.5664 11.5196 32.5664 11.5196L32.3905 10.7656C32.3165 10.9598 32.2094 11.2267 32.1371 11.4068C32.0882 11.5288 32.0552 11.6109 32.0594 11.6034Z" fill="#77A0F1" />
      <path fillRule="evenodd" clipRule="evenodd" d="M5.16252 8.40234H9.21152C9.76034 8.42078 10.2057 8.57903 10.3506 9.1379L11.2256 13.1358C11.2282 13.1436 11.2308 13.1514 11.2333 13.1591L11.5026 14.3693L13.9672 8.40234H16.6283L12.6727 17.1435H10.0114L7.76879 9.54171C6.99416 9.13419 6.1099 8.80648 5.12109 8.57915L5.16252 8.40234Z" fill="#77A0F1" />
    </svg>
  )
}

export const MastercardIcon = ({
  width = 27,
  height = 19,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width={width}
      height={height}
      role="presentation"
      viewBox="0 0 27 19"
      fill="none"
      {...props}
    >
      <path d="M19.4736 13.7666H14.4141V4.99609H19.4736V13.7666Z" fill="#FF5F00" />
      <path d="M14.7371 9.37917C14.7371 7.60003 15.6007 6.01522 16.9456 4.9939C15.9621 4.24707 14.7209 3.80131 13.372 3.80131C10.1785 3.80131 7.58984 6.29856 7.58984 9.37917C7.58984 12.4598 10.1785 14.957 13.372 14.957C14.7209 14.957 15.9621 14.5113 16.9456 13.7644C15.6007 12.7431 14.7371 11.1583 14.7371 9.37917Z" fill="#EB001B" />
      <path d="M26.2936 9.37917C26.2936 12.4598 23.705 14.957 20.5115 14.957C19.1626 14.957 17.9214 14.5113 16.9375 13.7644C18.2828 12.7431 19.1464 11.1583 19.1464 9.37917C19.1464 7.60003 18.2828 6.01522 16.9375 4.9939C17.9214 4.24707 19.1626 3.80131 20.5115 3.80131C23.705 3.80131 26.2936 6.29856 26.2936 9.37917Z" fill="#F79E1B" />
    </svg>
  )
}

export const SbpIcon = ({
  size = 24,
  width,
  height,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width={size || width}
      height={size || height}
      role="presentation"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path d="M5.18848 10.8232V13.1797L3.50195 15.8906L3.5 8.10449L5.18848 10.8232Z" fill="#5B57A2" stroke="#2B2E34"/>
      <path d="M13.8242 11.0996V9.40039L15.9736 8.21387L19.0566 8.21191L13.8242 11.0996Z" fill="#D90751" stroke="#2B2E34"/>
      <path d="M13.3098 6.32783L13.324 12.0595L10.6289 10.5678V2L13.3098 6.32783Z" fill="#FAB718"/>
      <path d="M20.9999 7.71183L15.8434 7.71616L13.3098 6.32783L10.6289 2L20.9999 7.71183Z" fill="#ED6F26"/>
      <path d="M13.324 17.666V14.8852L10.6289 13.4219L10.6304 21.9982L13.324 17.666Z" fill="#63B22F"/>
      <path d="M15.8373 16.2877L5.68865 10.6807L3 6.35156L20.989 16.2821L15.8373 16.2877Z" fill="#1487C9"/>
      <path d="M10.6328 22.0013L13.3261 17.6692L15.8393 16.2908L20.9911 16.2852L10.6328 22.0013Z" fill="#017F36"/>
      <path d="M3.00391 17.6449L10.6517 13.4249L8.08054 12.0039L5.6896 13.3242L3.00391 17.6449Z" fill="#984995"/>
    </svg>
  )
}

export const LockIcon = ({
  size = 32,
  width,
  height,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      aria-hidden="true" 
      focusable="false" 
      height={size || height} 
      role="presentation" 
      viewBox={`0 0 32 32`} 
      width={size || width} 
      {...props} 
      fill="none"
    >
      <path d="M24.1667 14.8359H7.83333C6.54467 14.8359 5.5 15.8806 5.5 17.1693V25.3359C5.5 26.6246 6.54467 27.6693 7.83333 27.6693H24.1667C25.4553 27.6693 26.5 26.6246 26.5 25.3359V17.1693C26.5 15.8806 25.4553 14.8359 24.1667 14.8359Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/> 
      <path d="M10.168 14.8359V10.1693C10.168 8.62217 10.7826 7.13844 11.8765 6.04448C12.9705 4.95052 14.4542 4.33594 16.0013 4.33594C17.5484 4.33594 19.0321 4.95052 20.1261 6.04448C21.2201 7.13844 21.8346 8.62217 21.8346 10.1693V14.8359" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export const InvoiceIcon = ({
  size = 32,
  width,
  height,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      aria-hidden="true" 
      focusable="false" 
      height={size || height} 
      role="presentation" 
      viewBox={`0 0 20 20`} 
      width={size || width} 
      {...props} 
      fill="none"
    >
      <path d="M11.6654 1.66406H4.9987C4.55667 1.66406 4.13275 1.83966 3.82019 2.15222C3.50763 2.46478 3.33203 2.8887 3.33203 3.33073V16.6641C3.33203 17.1061 3.50763 17.53 3.82019 17.8426C4.13275 18.1551 4.55667 18.3307 4.9987 18.3307H14.9987C15.4407 18.3307 15.8646 18.1551 16.1772 17.8426C16.4898 17.53 16.6654 17.1061 16.6654 16.6641V6.66406L11.6654 1.66406Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11.668 1.66406V6.66406H16.668" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13.3346 10.8359H6.66797" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13.3346 14.1641H6.66797" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.33464 7.5H7.5013H6.66797" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export const EyeIcon = ({
  size = 32,
  width,
  height,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      aria-hidden="true" 
      focusable="false" 
      height={size || height} 
      role="presentation" 
      viewBox={`0 0 18 18`} 
      width={size || width} 
      {...props} 
      fill="none"
    >
      <path d="M0.75 9C0.75 9 3.75 3 9 3C14.25 3 17.25 9 17.25 9C17.25 9 14.25 15 9 15C3.75 15 0.75 9 0.75 9Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export const EyeOffIcon = ({
  size = 32,
  width,
  height,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      height={size || height}
      role="presentation"
      viewBox={`0 0 18 18`}
      width={size || width}
      {...props}
      fill="none"
    >
      <path d="M0.75 9C0.75 9 3.75 3 9 3C14.25 3 17.25 9 17.25 9C17.25 9 14.25 15 9 15C3.75 15 0.75 9 0.75 9Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2.25 2.25L15.75 15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export const SuccessCheckIcon = ({
  size = 80,
  width,
  height,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      height={size || height}
      role="presentation"
      viewBox="0 0 81 80"
      width={size || width}
      {...props}
      fill="none"
    >
      <path
        d="M73.8347 36.9342V40.0009C73.8305 47.1889 71.503 54.1831 67.1991 59.9403C62.8952 65.6974 56.8456 69.9091 49.9525 71.9472C43.0594 73.9853 35.6922 73.7405 28.9495 71.2495C22.2069 68.7584 16.4502 64.1545 12.5378 58.1244C8.62552 52.0943 6.76727 44.9611 7.24022 37.7886C7.71318 30.6161 10.492 23.7886 15.1622 18.3244C19.8325 12.8602 26.1439 9.05212 33.1553 7.468C40.1666 5.88388 47.5022 6.60864 54.068 9.53419"
        stroke="#7EC40A"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M73.8333 13.332L40.5 46.6987L30.5 36.6987"
        stroke="#7EC40A"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const ReportIcon = ({
  size = 24,
  width,
  height,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      height={size || height}
      role="presentation"
      viewBox="0 0 24 24"
      width={size || width}
      {...props}
      fill="none"
    >
      <path d="M16 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15 2H9C8.44772 2 8 2.44772 8 3V5C8 5.55228 8.44772 6 9 6H15C15.5523 6 16 5.55228 16 5V3C16 2.44772 15.5523 2 15 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export const ActIcon = ({
  size = 24,
  width,
  height,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      height={size || height}
      role="presentation"
      viewBox="0 0 24 24"
      width={size || width}
      {...props}
      fill="none"
    >
      <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10 9H9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export const MapPinIcon = ({
  size = 32,
  width,
  height,
  ...props
}: IconSvgProps) => {
  return (
    <svg
      aria-hidden="true" 
      focusable="false" 
      height={size || height} 
      role="presentation" 
      viewBox={`0 0 18 18`} 
      width={size || width} 
      {...props} 
      fill="none"
    >
      <path d="M15.75 7.5C15.75 12.75 9 17.25 9 17.25C9 17.25 2.25 12.75 2.25 7.5C2.25 5.70979 2.96116 3.9929 4.22703 2.72703C5.4929 1.46116 7.20979 0.75 9 0.75C10.7902 0.75 12.5071 1.46116 13.773 2.72703C15.0388 3.9929 15.75 5.70979 15.75 7.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 9.75C10.2426 9.75 11.25 8.74264 11.25 7.5C11.25 6.25736 10.2426 5.25 9 5.25C7.75736 5.25 6.75 6.25736 6.75 7.5C6.75 8.74264 7.75736 9.75 9 9.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export const DoneIcon = ({
  size = 24,
  width,
  height,
  ...props
}: IconSvgProps) => {
  return (
    <svg aria-hidden="true" focusable="false" height={size || height} role="presentation" viewBox="0 0 24 24" width={size || width} {...props} fill="none">
      <path d="M6 10.5263L10.875 16L18 8" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel"/>
    </svg>
  )
}

export const MetroIcon = ({
  size = 16,
  width,
  height,
  ...props
}: IconSvgProps) => {
  return (
    <svg aria-hidden="true" focusable="false" height={size || height} role="presentation" viewBox="0 0 16 16" width={size || width} {...props} fill="none">
      <rect width="16" height="16" rx="8" fill="currentColor"/>
      <path d="M6.09187 5.68323C5.94796 5.17539 5.55734 5.23105 5.29027 5.46758C4.63237 6.10062 3.77573 7.42933 4.32398 9.34258C4.78314 10.9634 6.6937 12 6.6937 12H4.46649C4.46649 12 3.31649 10.6574 3.21369 9.07825C3.08349 7.08174 3.8511 5.82258 4.74201 5.00174C5.57809 4.22956 6.37306 4 6.37306 4L7.99922 9.55L9.62538 4C9.62538 4 10.4204 4.22956 11.2564 5.00174C12.1473 5.82258 12.915 7.08174 12.7847 9.07825C12.6819 10.6574 11.5319 12 11.5319 12H9.30474C9.30474 12 11.2151 10.9634 11.6745 9.34258C12.2227 7.42955 11.3661 6.10084 10.7082 5.46758C10.4409 5.23105 10.0503 5.17539 9.90657 5.68323C9.41314 7.3041 7.99942 11.9482 7.99942 11.9482C7.99942 11.9482 6.5857 7.30255 6.09228 5.68323H6.09187Z" fill="white"/>
    </svg>
  )
}

export const FacilityMapIcon = ({
  ...props
}: IconSvgProps) => {
  return (
    <svg aria-hidden="true" focusable="false" width='48' height='64' role="presentation" viewBox="0 0 48 64"  {...props} fill="none">
      <rect width="48" height="48" rx="8" fill="#2B2E34"/>
      <path d="M24 12.5L24 34M15 26.5L22.2071 33.7071C22.3946 33.8946 22.649 34 22.9142 34L25.0858 34C25.351 34 25.6054 33.8946 25.7929 33.7071L33 26.5" stroke="white" strokeWidth="2"/>
      <ellipse cx="24" cy="61.5" rx="5" ry="2.5" fill="#2B2E34"/>
      <rect x="23" y="48" width="2" height="14" fill="#2B2E34"/>
    </svg>
  )
}

export const UserIcon = ({
  size = 32,
  width,
  height,
  ...props
}: IconSvgProps) => {
  return (
    <svg aria-hidden="true" focusable="false" height={size || height} role="presentation" viewBox="0 0 30 30" width={size || width} {...props} fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M17.7643 3.21888L21.7811 7.23566C22.2414 7.69596 22.5 8.32025 22.5 8.9712V11.0288C22.5 11.6798 22.2414 12.304 21.7811 12.7643L17.7643 16.7811C17.304 17.2414 16.6798 17.5 16.0288 17.5H13.9712C13.3202 17.5 12.696 17.2414 12.2357 16.7811L8.21888 12.7643C7.75859 12.304 7.5 11.6798 7.5 11.0288V8.9712C7.5 8.32025 7.75859 7.69596 8.21888 7.23566L12.2357 3.21888C12.696 2.75859 13.3202 2.5 13.9712 2.5L16.0288 2.5C16.6798 2.5 17.304 2.75859 17.7643 3.21888ZM20.0331 11.0413C20.6082 10.4662 20.6082 9.53378 20.0331 8.95868L16.0413 4.96694C15.4662 4.39184 14.5338 4.39184 13.9587 4.96694L9.96694 8.95868C9.39184 9.53378 9.39184 10.4662 9.96694 11.0413L13.9587 15.0331C14.5338 15.6082 15.4662 15.6082 16.0413 15.0331L20.0331 11.0413Z" fill="currentColor"/>
      <path d="M5 26.4489H7.5V24.375C7.5 23.3395 8.33947 22.5 9.375 22.5H20.625C21.6605 22.5 22.5 23.3395 22.5 24.375V26.4489H25V25.0624C25 24.5651 24.8025 24.0882 24.4508 23.7365L21.2635 20.5492C20.9118 20.1975 20.4349 20 19.9376 20H10.0624C9.56508 20 9.08817 20.1975 8.73654 20.5492L5.54917 23.7365C5.19754 24.0882 5 24.5651 5 25.0624V26.4489Z" fill="#2B2E34"/>
    </svg>
  )
}

export const TelegramIcon = ({
  size = 24,
  width,
  height,
  ...props
}: IconSvgProps) => {
  return (
    <svg width={size || width} {...props} height={size || height} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.51239 12.749C10.418 10.2088 14.3559 8.5341 16.3263 7.72499C21.9521 5.41482 23.1211 5.01352 23.883 5.00013C24.0506 4.99736 24.4253 5.03836 24.668 5.23279C24.873 5.39697 24.9294 5.61876 24.9563 5.77442C24.9833 5.93008 25.0169 6.28467 24.9902 6.56174C24.6854 9.72419 23.3662 17.3986 22.6951 20.9406C22.4111 22.4394 21.852 22.9419 21.3107 22.9911C20.1343 23.098 19.2409 22.2235 18.1015 21.4861C16.3186 20.3323 15.3113 19.614 13.5807 18.488C11.5806 17.1868 12.8772 16.4716 14.017 15.3028C14.3153 14.9969 19.4986 10.3423 19.5989 9.92011C19.6115 9.8673 19.6231 9.67045 19.5046 9.56651C19.3862 9.46257 19.2114 9.49812 19.0852 9.52638C18.9064 9.56645 16.0581 11.4251 10.5403 15.1023C9.73187 15.6504 8.99958 15.9174 8.34347 15.9035C7.62016 15.888 6.2288 15.4997 5.19447 15.1678C3.92583 14.7606 2.91753 14.5454 3.00533 13.8539C3.05106 13.4938 3.55341 13.1255 4.51239 12.749Z" fill="currentColor"/>
    </svg>
  )
}

export const WhatsappIcon = ({
  size = 24,
  width,
  height,
  ...props
}: IconSvgProps) => {
  return (
    <svg width={size || width} {...props} height={size || height} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M22.4 5.45C20.15 3.2 17.15 2 14 2C7.4 2 2 7.4 2 14C2 16.1 2.60001 18.2 3.65001 20L2 26L8.30002 24.35C10.1 25.25 12.05 25.85 14 25.85C20.6 25.85 26 20.45 26 13.85C26 10.7 24.65 7.7 22.4 5.45ZM14 23.9C12.2 23.9 10.4 23.45 8.90001 22.55L8.59999 22.4L4.84999 23.45L5.90001 19.85L5.59999 19.4C4.54999 17.75 4.09999 15.95 4.09999 14.15C4.09999 8.75 8.6 4.25 14 4.25C16.7 4.25 19.1 5.3 21.05 7.1C23 9.05 23.9 11.45 23.9 14.15C23.9 19.4 19.55 23.9 14 23.9ZM19.4 16.4C19.1 16.25 17.6 15.5 17.3 15.5C17 15.35 16.85 15.35 16.7 15.65C16.55 15.95 15.95 16.55 15.8 16.85C15.65 17 15.5 17 15.2 17C14.9 16.85 14 16.55 12.8 15.5C11.9 14.75 11.3 13.7 11.15 13.4C11 13.1 11.15 12.95 11.3 12.8C11.45 12.65 11.6 12.5 11.75 12.35C11.9 12.2 11.9 12.05 12.05 11.9C12.2 11.75 12.05 11.6 12.05 11.45C12.05 11.3 11.45 9.8 11.15 9.2C11 8.75 10.7 8.75 10.55 8.75C10.4 8.75 10.25 8.75 9.94998 8.75C9.79998 8.75 9.49998 8.75 9.19998 9.05C8.89998 9.35 8.15001 10.1 8.15001 11.6C8.15001 13.1 9.19999 14.45 9.34999 14.75C9.49999 14.9 11.45 18.05 14.45 19.25C17 20.3 17.45 20 18.05 20C18.65 20 19.85 19.25 20 18.65C20.3 17.9 20.3 17.3 20.15 17.3C20 16.55 19.7 16.55 19.4 16.4Z" fill="currentColor"/>
    </svg>
  )
}